import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

export async function quitStudy(studyId: number) {
    const formData = new FormData();
    formData.append('study_id', `${studyId}`);

    try {
        const { status } = await axios.post(Endpoints.Study.Quit, formData);

        return status === 200;
    } catch (error) {
        return false;
    }
}
